// Documentação do Youtube IFrame Player API (ler em inglês):
// https://developers.google.com/youtube/player_parameters

import isObject from 'lodash/isObject';

function getYoutubeId(url) {
  const regex =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\\&v=)([^#\\&\\?]*).*/;
  const groups = regex.exec(url);
  return groups !== null ? groups[2] : null;
}

// recebe Objeto com url e configurações do iframe de vídeo
// url = String ou Objeto Url | controls/loop/mute/autoplay = Boolean
function youtubeEmbed({ url, controls, loop, mute, autoplay }) {
  const id = getYoutubeId(isObject(url) ? url.value : url);

  if (id !== null) {
    // eslint-disable-next-line prettier/prettier
    return `https://www.youtube.com/embed/${id}?rel=0&controls=${controls ? '1' : '0'}${loop ? `&loop=1&playlist=${id}` : ''}&mute=${mute ? '1' : '0'}&autoplay=${autoplay ? '1' : '0'}`;
  }

  return '';
}

// recebe String ou Objeto Url
function youtubeThumb(url) {
  const id = getYoutubeId(isObject(url) ? url.value : url);

  return id !== null ? `http://img.youtube.com/vi/${id}/0.jpg` : '';
}

export { youtubeEmbed, youtubeThumb };
